import { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axiosInstance from '../../../Config/axiosInstance';
import './EvaluationScore.css';

const EvaluationSupplierScore = ({ open, onClose, supplierId, onSaved }) => {
  const [criteria, setCriteria] = useState([]);
  const [ratings, setRatings] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
        axiosInstance.get('/evaluation-criterion/evaluationCriterion/?is_active=true')
        .then(res => {
          setCriteria(res.data);
          const initRatings = {};
          res.data.forEach(criterion => {
            initRatings[criterion.id] = '-';
          });
          setRatings(initRatings);
        })
        .catch(err => {
          console.error('Error fetching evaluation criteria:', err);
        });
    }
  }, [open]);

  const handleRatingChange = (criterionId, value) => {
    setRatings(prev => ({ ...prev, [criterionId]: value }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const requests = Object.entries(ratings)
        .filter(([, value]) => value !== '-')
        .map(([criterionId, score]) =>
          axiosInstance.post('/supplier-evaluation/', {
            evaluation: supplierId,
            criterion: parseInt(criterionId),
            score: parseInt(score)
          })
        );

      await Promise.all(requests);

      // 🔁 Actualizează media după salvare
      if (onSaved) {
        onSaved();
      }

      onClose();
    } catch (err) {
      console.error("Error saving evaluations:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Review Supplier</DialogTitle>
      <DialogContent dividers>
        {criteria.length === 0 ? (
          <Typography>No active evaluation criteria found.</Typography>
        ) : (
          criteria.map(criterion => (
            <Box key={criterion.id} className="criteriaBox" my={2}>
              <Typography className="labelText">{criterion.label}</Typography>
              <FormControl className="formControl" size="small" sx={{ mt: 1, minWidth: 120 }}>
                <InputLabel id={`rating-label-${criterion.id}`}>Score</InputLabel>
                <Select
                  labelId={`rating-label-${criterion.id}`}
                  value={ratings[criterion.id] || '-'}
                  label="Score"
                  onChange={(e) => handleRatingChange(criterion.id, e.target.value)}
                >
                  <MenuItem value="-">-</MenuItem>
                  {[1, 2, 3, 4, 5].map(num => (
                    <MenuItem key={num} value={num}>{num}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          ))
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EvaluationSupplierScore;
